import { axios } from '~/common/utils/request'
const commonPath = 'rest/erp/logistics/v3/'

// 品检设备列表
export const getEquipmentList = params => axios({
  url: `${commonPath}qc_equipent/list`,
  method: 'post',
  data: params
})

// 品检项列表
export const getQcTestList = params => axios({
  url: `${commonPath}qc_test/list`,
  method: 'post',
  data: params
})

// 品检项详情
export const getQcTestDetail = id => axios({
  url: `${commonPath}qc_test/detail_info/${id}`,
  method: 'get'
})

// 品检项编辑
export const editQcTestDetail = params => axios({
  url: `${commonPath}detail/qc_test`,
  method: 'put',
  data: params
})

/**
 * 品检规则列表
 * @param {Object} params
 */
export const getQcRuleList = params => axios({
  url: `${commonPath}qc_rule/list`,
  method: 'post',
  data: params
})

/**
 * 品检规则创建
 * @param {Object} params
 */
 export const addQcRule = params => axios({
  url: `${commonPath}qc_rule`,
  method: 'post',
  data: params
})

/**
 * 品检类型列表
 * @param {Object} params
 */
export const getQcCategoryList = params => axios({
  url: `${commonPath}qc_categ/list`,
  method: 'post',
  data: params
})
